export default "__VITE_ASSET__YwuDK8Fg__"